
<template lang="pug">
  div(style="")
    slot
    el-form(ref='form' :rules="rules" label-position="top" :model='form')
      // el-form-item(label='工號' prop="id" required)
        el-input(v-model='form.id' disabled)
      el-form-item(label='手機號碼：' prop="userTel")
        el-input(v-model='form.userTel' type="tel" maxlength="10" placeholder="" disabled)
      el-form-item(label='手機簡訊碼：' prop="code")
        el-input(v-model='form.code' placeholder="")
      el-col(style="text-align: center;")
        div(v-show="countdown_show") {{ time }}秒後可再次寄送
        el-button(type="primary" @click="sendCode" :disabled="button_disable") 重新寄送

     
      .cart__footer
        el-col(style="text-align: center;")
          el-button(type="primary" @click="submit") 登入
</template>
<script>
import { Loading } from 'element-ui'
import { sendVerificationCode, codeCheck, login } from '@/api/user'
import Cookies from 'js-cookie'

export default {
  name: 'LoginVerification',
  props: {
    userTel: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      form: {
        userTel: this.userTel
      },
      countdown_show: true,
      time: 60,
      button_disable: true,
      rules: {
        code: [{ required: true, message: '請輸入簡訊驗證碼', trigger: 'blur' }],
      },
    }
  },
  created() {
    if(!this.form.userTel){
      this.$router.go(-1);
      return
    }
    this.sendCode();
    // this.countdown_run()
  },
  methods: {
    countdown () {
      console.log("進入", this.time)
      this.time--;
      if(this.time !== 0){
        setTimeout(this.countdown, 1000);
      }else{
        this.button_disable= false
        this.countdown_show= false
      }
    },
    countdown_run () {
      this.time = 60;
      this.button_disable = true;
      this.countdown_show = true;
      this.countdown()
    },
    submit () {
      console.log(this.form)
      // 一般預約驗證
      this.$refs['form'].validate(valid => {
        if (!valid) return false
        // this.$emit('setData', this.form)
        // this.$router.push({ name: 'JoinVerification' })

        const params = {
          userTel: this.form.userTel,
          code: this.form.code
        }
        codeCheck(params).then(res=>{
          if (res.data.status === 1) {
            this.$alert("驗證碼錯誤", {confirmButtonText: '確認'})
            return false
          }
          login(params).then(__res=>{
            if (__res.data.status === 1) {
              this.$alert("尚未註冊會員", {confirmButtonText: '確認'})
              return false
            }
            this.$alert("登入成功，您可以立即預約洗衣服務。", {confirmButtonText: '確認'})
            Cookies.set("phone", this.form.userTel, { expires: 365 })
            let redirect = Cookies.get('redirect')
            if(redirect === 'orderList'){
              this.$router.replace({ name: 'orderList' })
            }else{
              this.$router.replace({ name: 'info' })
            }
            
            // this.$router.push({path:decodeURIComponent(url)});
          })
        })
      })
    },
    sendCode () {
      let __loading = Loading.service({text: '簡訊發送中，請稍候...'})
      const params = {
        userTel: this.form.userTel
      }
      sendVerificationCode(params).then((res)=>{
        console.log(res.data)
        __loading.close();
        if(res.data.status === 3){
          this.$alert("該手機號碼，今日發送已經到達上限3次，請明日再試", {confirmButtonText: '確認'})
          return false
        }
        else if (res.data.status !== 0) {
          this.$alert("發送失敗，請稍後再試", {confirmButtonText: '確認'})
          return false
        }
        this.$alert("發送成功，請查看簡訊驗證碼。", {confirmButtonText: '確認'})
        this.countdown_run ()
      })
    }
  },
}
</script>

<style scoped>
@media (min-width: 900px) {
  .el-form-item {
      margin: 0 6vw;
  }
}
</style>